import { renderSlot } from 'vue';

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return renderSlot(_ctx.$slots, "default");
}

export { render };
//# sourceMappingURL=collection-item.vue_vue_type_template_id_dd23be6a_lang.mjs.map
